/** A conversation's type, as the conversation lists show and filter it. */
export const CONVERSATION_TYPE_LABEL: Record<string, string> = {
  review: "Review",
  other: "Other",
};
